module.exports = __webpack_public_path__ + "media/images/area/area_fukuiM400-0acca2da47fa73cb97e92db1eab76072.jpg";